import React from 'react';
import Link from 'next/link';
import Button from '@mui/material/Button';
import Skeleton from '@mui/material/Skeleton';
import SvgStar from './SvgStar';
import { WPPostType } from '@/types/common';
import { ARTICLES_ROUTER_PATH } from '@/constants/router-path';

const POST_COUNT = 4;

const RecommendPost = (props: { fetchPosts: () => Promise<WPPostType[]> }) => {
  const { fetchPosts } = props;

  const [posts, setPosts] = React.useState<WPPostType[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    fetchPosts()
      .then((data) => {
        if (data && data.length > 0) {
          setPosts(data.slice(0, POST_COUNT));
        }
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 rounded-lg bg-web-grey-400 my-10">
      <div className="flex items-center">
        <SvgStar className="shrink-0" />
        <span className="ml-2 text-xl font-semibold">推荐阅读</span>
      </div>
      <ul className="list-none !ml-0">
        {loading
          ? Array.from({ length: POST_COUNT }).map((_, index) => (
              <li key={index} className="mt-6">
                <Skeleton variant="text" width="80%" height={20} />
                <Skeleton
                  variant="text"
                  width="100%"
                  height={16}
                  className="!mt-2"
                />
              </li>
            ))
          : posts.map(({ title, link, excerpt }, index) => (
              <li key={index} className="mt-6">
                <Link
                  href={link}
                  className="block text-sm font-semibold hover:underline"
                >
                  {title.rendered}
                </Link>
                <div
                  className="py-2 text-xs text-web-grey-600 border-b border-web-tertiary"
                  dangerouslySetInnerHTML={{ __html: excerpt.rendered }}
                />
              </li>
            ))}
      </ul>
      <div className="mt-3.5 text-center">
        <Button
          variant="contained"
          className="!w-[220px] !h-[42px] !bg-white !text-primary hover:!bg-web-neutral-300"
          LinkComponent={Link}
          href={ARTICLES_ROUTER_PATH}
          target="_blank"
        >
          阅读更多
        </Button>
      </div>
    </div>
  );
};

export default RecommendPost;
